var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSolicitudesPendientesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#663ea8;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.28,3.5H14.23a2.86,2.86,0,0,0-5.46,0h-4a1.58,1.58,0,0,0-.38,0,1.85,1.85,0,0,0-1,.55,2,2,0,0,0-.42.64,2,2,0,0,0-.15.77v14a2,2,0,0,0,.57,1.42,1.85,1.85,0,0,0,1,.55,2.34,2.34,0,0,0,.38,0H18.28a2,2,0,0,0,1.93-2V5.5A2,2,0,0,0,18.28,3.5ZM11.5,3.1h0a.67.67,0,1,1-.65.68v0A.66.66,0,0,1,11.5,3.1Zm4.88,6.52H6.74V8.18h9.64ZM6.74,12h4.31v1.45H6.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 17.18,
    cy: 16.81,
    r: 4.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.18,21.84a5,5,0,1,1,5-5A5,5,0,0,1,17.18,21.84Zm0-8.35a3.33,3.33,0,1,0,3.32,3.32A3.33,3.33,0,0,0,17.18,13.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.38,
    cy: 16.75,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.24,
    cy: 16.75,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.11,
    cy: 16.75,
    r: 0.81
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSolicitudesPendientesActive);
export default __webpack_public_path__ + "static/media/ic-solicitudes-pendientes-active.2bd57435446286280d04f7985344ac71.svg";
export { ForwardRef as ReactComponent };